export enum PriceRuleValueType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE',
}
